import { inject, observer } from "mobx-react";
import * as React from "react";
import { API } from "src/Services/Api/Api";

@inject('stores')
@observer
export default class TableauReport extends React.Component {
    public props: any;
    private API: API;

    constructor(props: any) {
        super(props);
        this.API = this.props.stores.Api;
    }

    public componentDidMount() {
        this.renderIframe();
    }

    private renderIframe() {
        const myFrame: any = document.getElementById('my_frame');
        this.API.get('/reports/tableautoken')
            .then(data => {
                if (data) {
                    myFrame.src = `https://tableau.mudmetrix.com/trusted/${data.token}/views/Recapv1_0/WellSummary`;
                }
            });
    }


    public render() {
        return (
            <iframe id="my_frame" style={{width: '100%', height: '95vh'}} />
        );
    }


}


// WEBPACK FOOTER //
// ./src/Components/Reporting/Tableau/TableauReport.tsx